// supprimer un projet

import React, { useState } from "react";
import "./deleteProjet.css";

import axios from "axios";
import { API_ROUTES } from "../../utils/constant";

const SupprimerProjet = () => {
  const [id, setId] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.delete(`${API_ROUTES.PROJETS}/${id}`);
      if (response.status === 200) {
        setId("");
        console.log("Projet supprimé avec succès.");
        setMessage("Projet supprimé avec succès !");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div className="supprimer-projet">
      <h2>Supprimer un projet</h2>
      <form onSubmit={handleSubmit}>
        <div className="supprimer-projet-input">
          <label htmlFor="id">ID</label>
          <input
            type="text"
            id="id"
            value={id}
            onChange={(event) => setId(event.target.value)}
          />
        </div>
        <button type="submit">Supprimer</button>
        {message && <p className="msg-success">{message}</p>}
      </form>
    </div>
  );
};

export default SupprimerProjet;
